import { Component, Input, OnInit } from '@angular/core';
import { ServiceCounts } from 'src/app/core/interfaces/status-counts/service-counts';

@Component({
  selector: 'app-service-counts',
  templateUrl: './service-counts.component.html',
  styleUrls: ['./service-counts.component.scss'],
})
export class ServiceCountsComponent implements OnInit {
  @Input() serviceCounts: ServiceCounts;

  constructor() {}

  ngOnInit(): void {}
}
